// https://react-aria.adobe.com/react-aria-components/Breadcrumbs.html
import {
  Breadcrumb as ReactAriaBreadcrumb,
  Breadcrumbs as ReactAriaBreadcrumbs,
} from 'react-aria-components';
import { Link as RouterLink } from 'react-router-dom';
import styles from './breadcrumb.module.scss';

export interface BreadcrumbItem {
  label: string;
  onClick?: VoidFunction;
  to?: string;
}

export interface BreadcrumbProps {
  items: BreadcrumbItem[];
}

export const Breadcrumb = ({ items }: BreadcrumbProps) => {
  const renderBreadcrumbLink = (
    item: BreadcrumbItem,
    isCurrentPage: boolean
  ) => {
    const { label, onClick, to } = item;

    if (isCurrentPage) {
      return <span className={styles.link}>{label}</span>;
    }

    if (to) {
      return (
        <RouterLink className={styles.link} to={to} onClick={onClick}>
          {label}
        </RouterLink>
      );
    }

    if (onClick) {
      return (
        <button className={styles.link} type="button" onClick={onClick}>
          {label}
        </button>
      );
    }

    return <span className={styles.link}>{label}</span>;
  };

  return (
    <ReactAriaBreadcrumbs className={styles.container}>
      {items.map((item, index) => {
        const isLast = index === items.length - 1;
        const isCurrentPage = isLast && items.length > 1;

        return (
          <ReactAriaBreadcrumb
            key={item.label}
            {...(isCurrentPage && { 'aria-current': 'page' as const })}
          >
            {renderBreadcrumbLink(item, isCurrentPage)}
            {!isLast && (
              <span aria-hidden="true" className={styles.separator}>
                /
              </span>
            )}
          </ReactAriaBreadcrumb>
        );
      })}
    </ReactAriaBreadcrumbs>
  );
};
